import { render, staticRenderFns } from "./UploadSourceSelector.vue?vue&type=template&id=3a7e2983&scoped=true"
import script from "./UploadSourceSelector.vue?vue&type=script&lang=js"
export * from "./UploadSourceSelector.vue?vue&type=script&lang=js"
import style0 from "./UploadSourceSelector.vue?vue&type=style&index=0&id=3a7e2983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7e2983",
  null
  
)

export default component.exports